import { render, staticRenderFns } from "./AdminEmployeeSignUp.vue?vue&type=template&id=5c4c50e6"
import script from "./AdminEmployeeSignUp.vue?vue&type=script&lang=js"
export * from "./AdminEmployeeSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports